
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CareersNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://public.readdy.ai/ai/img_res/5a0c2242-0ad2-42d9-9fe3-25bf4e6b12bb.png" 
              alt="Gentle Roots Home Care" 
              className="h-16 w-auto object-contain"
            />
          </Link>
          
          <div className="flex items-center gap-8">
            <Link 
              to="/" 
              className="font-medium text-[#2C2C2C] hover:text-[#6B8E6F] transition-colors cursor-pointer whitespace-nowrap"
            >
              Home
            </Link>
            <Link 
              to="/careers" 
              className="font-medium text-[#6B8E6F] transition-colors cursor-pointer whitespace-nowrap"
            >
              Careers
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
